module.exports = __webpack_public_path__ + "img/campaign_black_18dp.48ced8c2.svg";